<template>
  <div class="main-wrap">
    <div class="Filter-wrap">
      <div style="width: 1380px">
        <div class="f-w-data">
          <div class="f-w-d-wrap">
            <div class="name">
              <span>分类 ：</span>
            </div>
            <div class="items">
              <span
                :class="c.value == S_category ? 'active' : ''"
                v-for="(c, index) in showDataCategory"
                :key="index"
                @click="remoteData['product.category'] = c.value"
                >{{ c.label }}</span
              >
            </div>
          </div>
          <div class="f-w-d-wrap">
            <div class="name">
              <span>材质 ：</span>
            </div>
            <div class="items">
              <span
                :class="c.value == S_material ? 'active' : ''"
                v-for="(c, index) in showDataMaterial"
                :key="index"
                @click="remoteData['product.material'] = c.value"
                >{{ c.label }}</span
              >
            </div>
          </div>
          <div class="f-w-d-wrap">
            <div class="name">
              <span>价格 ：</span>
            </div>
            <div class="items">
              <span
                :class="
                  c.value[0] + '-' + c.value[1] == S_price ? 'active' : ''
                "
                v-for="(c, index) in showDataPrice"
                :key="index"
                @click="
                  remoteData['product.minPrice'] = c.value[0];
                  remoteData['product.maxPrice'] = c.value[1];
                "
                >{{ c.label }}</span
              >
              <!--<span class="price" style="width: 100px;margin: 0">-->
              <!--<el-input-->
              <!--placeholder="" size="small"-->
              <!--v-model="remoteData['product.minPrice']">-->
              <!--<i slot="prefix" class="el-input__icon iconfont icon-meiyuan"></i>-->
              <!--</el-input>-->
              <!--</span>-->
              <!--~-->
              <!--<span class="price" style="margin-left: 0;width: 100px;margin: 0">-->
              <!--<el-input-->
              <!--placeholder="" size="small"-->
              <!--v-model="remoteData['product.maxPrice']">-->
              <!--<i slot="prefix" class="el-input__icon iconfont icon-meiyuan"></i>-->
              <!--</el-input>-->
              <!--</span>-->
            </div>
          </div>
          <div class="f-w-d-wrap">
            <div class="name">
              <span>评论 ：</span>
            </div>
            <div class="items">
              <span
                :class="c.value == S_reviewRate ? 'active' : ''"
                v-for="(c, index) in showDataReviewRate"
                :key="index"
                @click="remoteData['product.reviewRate'] = c.value"
                >{{ c.label }}</span
              >
            </div>
          </div>
          <div class="f-w-d-wrap">
            <div class="name">
              <span>销量 ：</span>
            </div>
            <div class="items">
              <span
                :class="c.value == S_saleNum ? 'active' : ''"
                v-for="(c, index) in showDataSaleNum"
                :key="index"
                @click="remoteData['product.saleNum'] = c.value"
                >{{ c.label }}</span
              >
            </div>
          </div>
        </div>
        <div class="f-w-sort">
          <div class="f-w-s-wrap">
            <div class="name">
              <span>综合排序：</span>
            </div>
            <div class="items">
              <span
                style="cursor:pointer;"
                :class="S_asc === '' ? 'active' : ''"
                @click="
                  remoteData.priceOrderAsc = '';
                  remote();
                "
                >默认</span
              >
              <span
                style="cursor:pointer;"
                :class="S_asc === false ? 'active' : ''"
                @click="
                  remoteData.priceOrderAsc = false;
                  remote();
                "
                >价格从高到低 <i class="iconfont icon-gaodaodihui"></i
              ></span>
              <span
                style="cursor:pointer;"
                :class="S_asc === true ? 'active' : ''"
                @click="
                  remoteData.priceOrderAsc = true;
                  remote();
                "
                >价格从低到高 <i class="iconfont icon-didaogaohui"></i
              ></span>
              <div class="f-w-input" style="margin-left: 30px;width: 300px;">
                <el-input
                  placeholder="例：bags for women"
                  size="small"
                  v-model="input"
                  class="m-w-bar-input"
                  @keyup.enter.native="remote('search')"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="remote('search')"
                    style="cursor: pointer"
                  ></i>
                </el-input>
              </div>
              <!--<span class="price" style="margin-left: 10px;">-->
              <!--<el-button size="small" style="color: #9E9E9E;">确定</el-button>-->
              <!--</span>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Product-wrap">
      <div style="width:1380px;padding: 20px 0 0 0">
        <div class="p-w-list">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="img">
              <img
                :src="
                  /(https:\/\/images-na.ssl-images-amazon.com\/images\/I\/[A-z0-9\-%]+).*/.exec(
                    item.Image
                  )[1] + '.jpg'
                "
                alt=""
              />

              <!-- <div class="find">
                <div class="find-similar">
                  找相似
                </div>
                <div class="platform">
                  <span class="find-item" @click="findSimilar(item.Image, 4)">
                    百度
                  </span>
                </div>
              </div> -->
              <div class="echart" :class="`echartDiv${index}`"></div>
            </div>
            <div class="product-msg">
              <p>{{ item.Title }}</p>
              <div class="price">
                <span>{{
                  item.PriceMin > 0 ? `USD ${item.PriceMin}` : ""
                }}</span>
                <el-rate
                  :value="
                    (item.ReviewItem1 +
                      2 * item.ReviewItem2 +
                      3 * item.ReviewItem3 +
                      4 * item.ReviewItem4 +
                      5 * item.ReviewItem5) /
                      100
                  "
                  disabled
                  text-color="#ff9900"
                >
                </el-rate>
              </div>
            </div>
          </div>
          <div
            v-show="total < 1"
            style="font-size: 16px;text-align: center;color: #9E9E9E;height: 170px;"
          >
            暂无符合条件的产品
          </div>
        </div>
      </div>
    </div>
    <div class="Pagination-wrap">
      <div style="width: 1390px;display: flex;justify-content: start">
        <el-pagination
          @current-change="pagchange"
          v-show="total != 0"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
          :page-size="remoteData['pagination.pageSize']"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { productList } from "./product.js";

export default {
  data() {
    return {
      input: "",
      list: [],
      total: 0,
      value1: "3",
      category: "",
      material: "",
      minPrice: 0,
      maxPrice: 1000000,
      reviewNum: "",
      saleNum: "",
      remoteData: {
        "pagination.pageSize": 20,
        "pagination.pageNo": 1,
        "product.category": "",
        "product.material": "",
        "product.minPrice": "",
        "product.maxPrice": "",
        "product.reviewRate": "",
        "product.saleNum": "",
        priceOrderAsc: "",
      },
      showDataCategory: [
        { label: "全部", value: "" },
        { label: "斜挎包", value: "Crossbody Bags" },
        { label: "单肩包", value: "Shoulder Bags" },
        { label: "双肩包", value: "Backpacks" },
        { label: "手提包", value: "Top-Handle Bags" },
        { label: "背包", value: "Casual Daypacks" },
        { label: "钱包", value: "Wallets" },
        { label: "儿童书包", value: "Kids' Backpacks" },
        { label: "收纳包", value: "Handbag Organizers" },
        { label: "手包", value: "Clutches" },
        { label: "休闲包", value: "Hobo Bags" },
      ],
      showDataMaterial: [
        { label: "全部", value: "" },
        { label: "聚脂纤维", value: "Polyester" },
        { label: "尼龙", value: "Canvas" },
        { label: "帆布", value: "Nylon" },
        { label: "皮革", value: "Leather" },
        { label: "塑料", value: "Plastic" },
      ],
      showDataPrice: [
        { label: "全部", value: ["", ""] },
        { label: "<10美元", value: [0, 10] },
        { label: "10美元 ~ 30美元", value: [10, 30] },
        { label: "30美元 ~ 60美元", value: [30, 60] },
        { label: ">60美元", value: [60, 1000000] },
      ],
      showDataReviewRate: [
        { label: "全部", value: "" },
        { label: "5星", value: 5 },
        { label: "4.5星", value: 4.5 },
        { label: "4星", value: 4 },
        { label: "3.5星", value: 3.5 },
        { label: "3星", value: 3 },
        { label: "低于3星", value: 2.99 },
      ],
      showDataSaleNum: [
        { label: "全部", value: "" },
        { label: "0+", value: "0" },
        { label: "50+", value: "50" },
        { label: "100+", value: "100" },
        { label: "200+", value: "200" },
        { label: "300+", value: "300" },
        { label: "500+", value: "500" },
      ],
      myChart: "",
    };
  },
  computed: {
    S_category() {
      return this.remoteData["product.category"];
    },
    S_material() {
      return this.remoteData["product.material"];
    },
    S_price() {
      return (
        this.remoteData["product.minPrice"] +
        "-" +
        this.remoteData["product.maxPrice"]
      );
    },
    S_reviewRate() {
      return this.remoteData["product.reviewRate"];
    },
    S_saleNum() {
      return this.remoteData["product.saleNum"];
    },
    S_asc() {
      return this.remoteData["priceOrderAsc"];
    },
  },
  watch: {
    remoteData: {
      handler() {
        this.remote();
      },
      deep: true,
    },
  },
  created() {
    this.remote();
  },
  mounted() {},
  methods: {
    pagchange(val) {
      this.remoteData["pagination.pageNo"] = val;
    },
    findSimilar(url, type) {
      this.$axios
        .post("/student/product/same", { url: url, type: type })
        .then((res) => {
          if (res.succeed) {
            window.open(res.uploader, "_blank");
          } else {
            this.$message.error(res.message);
          }
        });
    },
    remote(search) {
      if (search) {
        this.remoteData["product.keyword"] = this.input;
      } else {
        this.remoteData["product.keyword"] = "";
      }
      function fetchData(dataSource, pageNo, pageSize) {
        const startIndex = (pageNo - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        const data = dataSource.slice(startIndex, endIndex);
        return data;
      }
      this.list = fetchData(
        productList.items,
        this.remoteData["pagination.pageNo"],
        20
      );
      this.total = productList.pagination.total;
      // this.$axios
      //   .post("/student/analysis/search", this.remoteData)
      //   .then((res) => {
      //     if (res.succeed) {
      //       this.list = res.items;
      //       this.remoteData["pagination.pageNo"] = res.pagination.pageNo;
      //       this.total = res.pagination.total;
      //     }
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-wrap {
  .Filter-wrap {
    display: flex;
    justify-content: center;
    background: #ffffff;

    .f-w-data {
      border: 1px solid #dcdcdd;
      border-radius: 10px;
      margin-top: 20px;

      .f-w-d-wrap {
        display: flex;
        border-bottom: 1px dashed #dcdcdd;
        padding: 9px 20px;

        &:last-child {
          border-bottom: 1px dashed transparent;
        }

        > div {
          display: flex;
          align-items: center;

          &.name {
            width: 80px;
          }

          &.items {
            display: flex;
            align-items: center;

            > span {
              padding: 8px 12px;
              border-radius: 26px;
              margin: 0 10px;
              cursor: pointer;

              &.active {
                background: #fd0000;
                color: #ffffff;
              }
            }
          }

          > span {
            font-size: 16px;
            color: #33475d;
          }
        }
      }
    }

    .f-w-sort {
      margin: 20px 0;
      border: 1px solid #dcdcdd;
      border-radius: 10px;
      overflow: hidden;

      .f-w-s-wrap {
        display: flex;
        background: #f2f2f3;

        > div > span {
          padding: 8px 12px;
          font-size: 16px;
          color: #33475d;
        }

        > div.name {
          width: 130px;
          height: 56px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #ffffff;
          border-right: 1px solid #dcdcdd;
        }

        > div.items {
          display: flex;
          align-items: center;

          span {
            padding: 8px 12px;
            border-radius: 26px;
            margin-left: 30px;

            &.price {
              width: 72px;
              padding: 0;
            }

            &.active {
              background: #fd0000;
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  .Product-wrap {
    display: flex;
    justify-content: center;
    background: #e3f1fc;

    .p-w-list {
      display: flex;
      flex-wrap: wrap;

      .item {
        width: 260px;
        height: 370px;
        border-radius: 6px;
        overflow: hidden;
        margin: 0 10px 20px 10px;

        &:nth-child(5n-4) {
          margin: 0px 8px 20px 0px;
        }

        &:nth-child(5n) {
          margin: 0 0px 20px 8px;
        }

        .img {
          position: relative;
          height: 260px;
          width: 260px;
          display: flex;
          justify-content: center;
          background: #ffffff;

          &:hover div.find {
            height: 40px;
            overflow: auto;
          }

          > img {
            height: 100%;
          }

          div.icon {
            position: absolute;
            top: 8px;
            right: 8px;
            color: #ffffff;
            font-size: 14px;
            width: 104px;
            height: 24px;
            border-radius: 6px;
            background: #fd0000;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 10px;

            span {
              cursor: pointer;

              &:hover {
                text-shadow: 0 0 3px #ffffff;
              }
            }
          }

          div.find {
            /*height: 40px;*/
            width: 100%;
            position: absolute;
            bottom: 0;
            background: rgba(75, 131, 255, 0.8);
            font-size: 14px;
            display: flex;
            color: #ffffff;
            align-items: center;
            height: 0;
            overflow: hidden;
            z-index: 9999;

            div.find-similar {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 75px;
              height: 40px;
              border-right: 1px solid rgba(255, 255, 255, 0.5);
            }

            div.platform {
              width: calc(100% - 75px);
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 20px;
              color: #bdcbf4;

              &.active {
                color: #ffffff;
              }

              > span {
                cursor: pointer;

                &:hover {
                  color: #ffffff;
                }
              }
            }
          }

          div.echart {
            width: 100%;
            height: calc(100% - 80px);
            position: absolute;
            bottom: 40px;
            left: 0;
          }
        }

        .product-msg {
          background: #ffffff;
          padding: 12px 16px;
          height: 110px;

          p {
            color: #7b97b7;
            font-size: 12px;
            margin-bottom: 12px;
            height: 55px;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            line-height: 18px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }

          div.price {
            color: #ffa523;
            font-size: 14px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
  }

  .Pagination-wrap {
    padding-bottom: 60px;
    display: flex;
    justify-content: center;
    background: #e3f1fc;
  }
}
</style>
